module.exports = __webpack_public_path__ + "img/icon-over-pedido-libros.3edf2f30.svg";